import React from 'react';
export const ScienceSection = () => {
  return <section style={{
    backgroundColor: '#f0f4f6'
  }} className="p-6 mb-10" data-id="element-156">
      <h2 className="text-4xl font-bold mb-4" style={{
      color: '#465866'
    }} data-id="element-157">
        How 'Swaddling Science' Works for Dogs
      </h2>
      <p className="text-xl mb-4 italic" data-id="element-158">
        "Think about how we calm human babies - we swaddle them. The gentle,
        consistent pressure releases natural calming chemicals and provides
        security.
      </p>
      <p className="text-xl mb-4 italic" data-id="element-159">
        Dogs have the exact same nervous system response.
      </p>
      <div className="w-full h-[350px] mb-6 overflow-hidden" data-id="element-160">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2NwDk4LH3NcofuVnBT9gkD/Screenshot_2025-07-09_152413.png" alt="Yellow Labrador wearing a green calming vest" className="w-full h-full object-contain" data-id="element-161" />
      </div>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-162">
        The Natural Process:
      </h3>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-163">
        <li className="mb-1" data-id="element-164">
          Gentle pressure activates pressure points on the torso
        </li>
        <li className="mb-1" data-id="element-165">
          Endorphins release naturally (the body's own 'calm' chemicals)
        </li>
        <li className="mb-1" data-id="element-166">
          Nervous system switches from 'fight or flight' to 'rest and digest'
        </li>
        <li className="mb-1" data-id="element-167">
          Dog experiences calm without compromising their personality
        </li>
      </ul>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-168">
        Why This Works Better Than Medication:
      </h3>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-169">
        <li className="mb-1" data-id="element-170">
          Immediate results (no waiting weeks for 'therapeutic levels')
        </li>
        <li className="mb-1" data-id="element-171">No side effects (working with natural systems)</li>
        <li className="mb-1" data-id="element-172">Dog stays themselves (personality intact)</li>
        <li className="mb-1" data-id="element-173">
          Works for multiple triggers (storms, separation, travel, etc.)
        </li>
      </ul>
      <div style={{
      backgroundColor: 'white',
      borderColor: '#76a0b4'
    }} className="p-4 rounded-lg border mb-6" data-id="element-174">
        <h3 className="text-3xl font-bold mb-2" style={{
        color: '#465866'
      }} data-id="element-175">
          The PawEase Difference:
        </h3>
        <p className="text-xl mb-4 italic" data-id="element-176">
          After extensive research, I found that most compression vests fail
          because they don't apply pressure correctly. PawEase was specifically
          designed based on veterinary understanding of canine anatomy and
          pressure points.
        </p>
        <p className="text-xl mb-4 italic" data-id="element-177">
          It's not just a vest - it's therapeutic compression designed by
          professionals who understand how dogs' bodies actually work."
        </p>
      </div>
    </section>;
};